module.exports = __webpack_public_path__ + "static/intro-c79802fc4bd5ef45a4a453224da5195e.mp4";